import React, {memo, useState} from 'react';
import {
  NavigationItem,
  SubNavigationDropdown,
  SubNavigationItem,
} from './components';

import {Constants} from 'helpers';
import {
  Billing,
  Cases,
  CustomList2,
  Developers2,
  Events,
  ManageFlows,
  Profiles,
  QuickActionsIcon,
  Settings,
} from 'components/images/sidebar';

const ProfiledRiskSideNavigations = memo(
  ({media, splitLocation, openDropdown, toggleSubRoute}) => {
    const [hoveredDropdown, setHoveredDropdown] = useState({});

    const handleHoverChange = (dropdownKey, isHovered) => {
      setHoveredDropdown(prev => ({
        ...prev,
        [dropdownKey]: isHovered,
      }));
    };

    return (
      <section className="font-sans">
        <div className="">
          <NavigationItem
            media={media}
            title={<div className="flex items-center gap-2">Overview</div>}
            to={Constants.PAGES_URL.PROFILED_RISK_OVERVIEW}
            IconComponent={QuickActionsIcon}
          />
        </div>
        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center gap-2">Profiles</div>}
            to={Constants.PAGES_URL.PROFILED_RISK_PROFILES}
            IconComponent={Profiles}
          />
        </div>
        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center gap-2">Cases</div>}
            to={Constants.PAGES_URL.OVERVIEW_PENDING_CASES}
            IconComponent={Cases}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center gap-2">Events</div>}
            to={Constants.PAGES_URL.PROFILED_RISK_EVENTS}
            IconComponent={Events}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title="Manage Flows"
            active={splitLocation[1] === ''}
            to={Constants.PAGES_URL.FLOWS}
            onHoverChange={isHovered =>
              handleHoverChange('riskLogic', isHovered)
            }
            IconComponent={ManageFlows}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title={<div className="flex items-center gap-2">Custom list</div>}
            to={Constants.PAGES_URL.CUSTOM_LISTS}
            IconComponent={CustomList2}
          />
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title="Configuration"
            onHoverChange={isHovered =>
              handleHoverChange('settings', isHovered)
            }
            to={Constants.PAGES_URL.PROFILED_RISK_CONFIGURATION}
            IconComponent={Settings}
          />
        </div>

        <div className="flex flex-col mt-2">
          <NavigationItem
            media={media}
            title="Billing"
            active={splitLocation[1] === ''}
            to={Constants.PAGES_URL.PROFILED_RISK_TRANSACTIONS}
            onHoverChange={isHovered => handleHoverChange('billing', isHovered)}
            IconComponent={Billing}
          />
          {/*<NavigationItem*/}
          {/*  media={media}*/}
          {/*  title="Events Usage"*/}
          {/*  active={splitLocation[1] === ''}*/}
          {/*  to={Constants.PAGES_URL.PROFILED_RISK_EVENTS}*/}
          {/*  onHoverChange={isHovered =>*/}
          {/*    handleHoverChange('billing', isHovered)*/}
          {/*  }*/}
          {/*/>*/}
        </div>

        <div className="mt-2">
          <NavigationItem
            media={media}
            title="Developers"
            onHoverChange={isHovered =>
              handleHoverChange('developers', isHovered)
            }
            to={Constants.PAGES_URL.DEVELOPERS_CONFIGURATION}
            IconComponent={Developers2}
          />
        </div>

        <div className="flex flex-col">
          <SubNavigationDropdown
            media={media}
            IconComponent={Settings}
            label="Settings"
            subRoutes={[
              Constants.PAGES_URL.SETTINGS_PROFILE,
              Constants.PAGES_URL.SETTINGS_COMPANY_VERIFICATION,
              Constants.PAGES_URL.SETTINGS_ORGANISATION,
              Constants.PAGES_URL.SETTINGS_TEAM,
            ]}
            isChildHovered={hoveredDropdown['settings']}
            toggleSubRoute={() => toggleSubRoute('settings')}
            open={openDropdown === 'settings'}
          />

          {openDropdown === 'settings' && (
            <>
              <div className="flex-col flex">
                <SubNavigationItem
                  media={media}
                  title="Profile"
                  active={splitLocation[1] === ''}
                  onHoverChange={isHovered =>
                    handleHoverChange('settings', isHovered)
                  }
                  to={Constants.PAGES_URL.SETTINGS_PROFILE}
                />

                <SubNavigationItem
                  media={media}
                  className="rounded-b-lg"
                  title="Email Notifications"
                  onHoverChange={isHovered =>
                    handleHoverChange('settings', isHovered)
                  }
                  active={splitLocation[1] === ''}
                  to={Constants.PAGES_URL.SETTINGS_EMAIL_NOTIFICATIONS}
                />

                <SubNavigationItem
                  media={media}
                  title="Team"
                  active={splitLocation[1] === ''}
                  onHoverChange={isHovered =>
                    handleHoverChange('settings', isHovered)
                  }
                  to={Constants.PAGES_URL.SETTINGS_TEAM}
                />
              </div>
            </>
          )}
        </div>
      </section>
    );
  },
);

export default ProfiledRiskSideNavigations;
